import { Component, Input } from '@angular/core';
import { WFStepLocalResource, WFSectionLocalResource, WfTaskLocalResource } from 'src/app/components/workflow/workflow';

@Component({
  selector: 'checklist-task-counter',
  templateUrl: './checklist-task-counter.component.html',
  styleUrls: ['./checklist-task-counter.component.scss']
})
export class ChecklistTaskCounterComponent {

  @Input() step?: WFStepLocalResource;
  @Input() section?: WFSectionLocalResource;

  componentsToCheck = [0, 1];

  /**
   * Returns the number of visible signature tasks in the current step or section.
   */
  get totalTasks(): number {
    return this.getTasks().length;
  }

  /**
   * Returns the number of completed visible signature tasks in the current step or section.
   */
  get completedTasks(): number {
    return this.getTasks().filter(task => task.isCompleted).length;
  }

  /**
   * Reads tasks directly from the checklist hierarchy so condition changes are reflected immediately.
   * @returns Visible signature tasks owned by the configured step or section.
   */
  private getTasks(): WfTaskLocalResource[] {
    const tasks = this.section
      ? (this.section.wfStepLocals ?? []).flatMap(step => step.wfTaskLocals ?? [])
      : this.step?.wfTaskLocals ?? [];

    return tasks.filter(task =>
      task.required &&
      !!task.component &&
      this.componentsToCheck.includes(task.component.type)
    );
  }
}
